/*
 * soldout-tracking.js (Phase 1, v2.1)
 * 発火条件: ページに data-soldout-banner="top" or "bottom" の要素が存在 (= tag phase1-soldout-cta + product.available==false)
 * 計測イベント (GA4 探索レポートフィルタと完全一致する5種のみ):
 *   - notify_signup               (再入荷通知 登録成功時、window.__soldoutNotifySignup 経由で restock-notify.liquid から発火)
 *   - soldout_related_click       (在庫あり/関連商品カードクリック same-series / same-brand)  ← 必達KPI
 *   - soldout_brand_link_click    (banner代替導線 brand枠)
 *   - soldout_series_link_click   (banner代替導線 series枠 + 既存restock-notify__series-link)
 *   - soldout_designer_link_click (banner代替導線 designer枠)
 * 共通parameter:
 *   source_product_id / source_handle / source_vendor / source_series / availability='OutOfStock'
 */
(function () {
  if (window.__soldoutTrackingInit) return;
  window.__soldoutTrackingInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); return; }
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    var bannerTop = document.querySelector('[data-soldout-banner="top"]');
    var bannerBottom = document.querySelector('[data-soldout-banner="bottom"]');
    var source = bannerTop || bannerBottom;
    if (!source) return; // tag条件下にない or 在庫あり: 何もしない

    var src = {
      id: source.getAttribute('data-source-product-id') || '',
      handle: source.getAttribute('data-source-handle') || '',
      vendor: source.getAttribute('data-source-vendor') || '',
      series: source.getAttribute('data-source-series') || '(none)'
    };

    function send(name, extra) {
      if (typeof gtag !== 'function') return;
      var payload = {
        source_product_id: src.id,
        source_handle: src.handle,
        source_vendor: src.vendor,
        source_series: src.series,
        availability: 'OutOfStock'
      };
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
      }
      try { gtag('event', name, payload); } catch (e) {}
    }

    function handleFromHref(href) {
      if (!href) return '';
      var path = href.split('?')[0].split('#')[0];
      var idx = path.indexOf('/products/');
      if (idx === -1) return '';
      var rest = path.slice(idx + '/products/'.length);
      return rest.split('/')[0] || '';
    }

    // 1. 代替導線3枠クリック (soldout-banner bottom の中。枠ごとに専用イベントのみ)
    if (bannerBottom) {
      bannerBottom.addEventListener('click', function (ev) {
        var el = ev.target.closest('[data-soldout-alt]');
        if (!el) return;
        var altType = el.getAttribute('data-soldout-alt');

        if (altType === 'brand') {
          send('soldout_brand_link_click', {
            brand: el.getAttribute('data-target-vendor') || src.vendor
          });
        } else if (altType === 'series') {
          send('soldout_series_link_click', {
            series: el.getAttribute('data-target-series') || src.series,
            brand: src.vendor,
            target_collection: el.getAttribute('href') || ''
          });
        } else if (altType === 'designer') {
          send('soldout_designer_link_click', {
            designer: el.getAttribute('data-target-designer') || '',
            target_url: el.getAttribute('href') || '',
            link_kind: 'designer_collection'
          });
        }
      }, { passive: true });
    }

    // 2. 在庫あり/関連商品カードクリック (same-series / same-brand)  ← 必達KPI
    var relatedSections = document.querySelectorAll('[data-soldout-related-section]');
    for (var i = 0; i < relatedSections.length; i++) {
      (function (wrapper) {
        var relationType = wrapper.getAttribute('data-soldout-related-section') || '';
        wrapper.addEventListener('click', function (ev) {
          var link = ev.target.closest('a[href*="/products/"]');
          if (!link || !wrapper.contains(link)) return;
          var href = link.getAttribute('href') || '';
          send('soldout_related_click', {
            relation_type: relationType,
            target_handle: handleFromHref(href),
            target_url: href
          });
        }, { passive: true });
      })(relatedSections[i]);
    }

    // 3. 既存 restock-notify__series-link クリック (snippet 側で <a> として存在)
    var seriesLink = document.querySelector('.restock-notify__series-link');
    if (seriesLink) {
      seriesLink.addEventListener('click', function () {
        send('soldout_series_link_click', {
          series: src.series,
          brand: src.vendor,
          target_collection: seriesLink.getAttribute('href') || '',
          link_origin: 'restock-notify'
        });
      }, { passive: true });
    }

    // 4. notify_signup イベント発火関数を window に公開 (restock-notify.liquid 内 doSubmit success 分岐から呼ぶ)
    window.__soldoutNotifySignup = function (signupType) {
      send('notify_signup', {
        signup_type: signupType || 'same_product',
        signup_value: 1
      });
    };
  });
})();
